import React from 'react';
import { ModifiersState } from './modifiersState/ModifiersState';
import style from './index.module.scss';
import { Modifiers } from './components/Modifiers/Modifiers';
import { ModifiersControlPanel } from './components/ModifiersControlPanel/ModifiersControlPanel';
import { ModalWindows } from './components/ModalWindows';

export const ModifiersPageV2: React.FC = () => {
	return (
		<ModifiersState>
			<div className={style.container} data-test="ModifiersPage">
				<ModifiersControlPanel />
				<Modifiers />
				<ModalWindows />
			</div>
		</ModifiersState>
	);
};
